import { useReward } from '@/contexts/reward-context';

export const ProgressIndicator = ({
	title,
	finishedCount,
	totalCount
}: {
	title?: string;
	finishedCount: number;
	totalCount: number;
}) => {
	const { planInfo } = useReward();
	const vipLevel = planInfo?.VipLevel ?? 0;

	return (
		<div className="shop-coin-head__group-title">
			<div className="reward-badge-level" data-level={vipLevel}>
				<div className="reward-badge-level__img"></div>
			</div>
			{title}({finishedCount}/{totalCount})
		</div>
	);
};